import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'
import { apiStoreLenses } from 'root/src/client/logic/api/lenses'

const { pathOrTopContributorsChild } = apiStoreLenses

export default (state) => {
	const currentRouteRecordId = currentRouteParamsRecordId(state)
	return pathOrTopContributorsChild(currentRouteRecordId, [], state)
}
